import AppHeader from '../AppHeader'

export default {
  name: 'message-sent-officer',
  computed: {
  },
  methods: {
    goTop: function () {
      this.$router.push({ path: '/'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/message-sent-officer.js